<template>
  <div>
    <Loader :loading="uploadingFiles" class="loader-s">
      <input
        class="attachmentInput__input"
        type="file"
        :id="id"
        @change="handleFiles"
        accept=".doc, .docx, .png, .jpg, .jpeg, .gif, .pdf, .ppt, .pptx, .xls, .xlsx"
        multiple="multiple"
        :disabled="disabled"
      />
      <label
        :class="[
          'attachmentInput__label',
          'button',
          'primary',
          disabled ? 'disabled' : null,
        ]"
        :for="id"
        >{{ t.getOrKey("Button.AddFile") }}</label
      >
    </Loader>
    <div
      v-if="Array.isArray(attachments) && attachments.length > 0"
      class="attachmentListing"
    >
      <div
        v-for="attachment in attachments"
        class="attachmentListing__item"
        :key="attachment.id"
      >
        <span class="attachmentListing__item__fileName">
          {{ attachment.fileName }}
        </span>
        <font-awesome-icon
          class="success"
          :icon="['fas', 'check']"
        ></font-awesome-icon>
        <button
          class="error attachmentListing__item__deleteBtn button-xs"
          @click="deleteFile(attachment)"
          type="button"
          v-if="!disabled"
        >
          {{ t.getOrKey("Button.Delete") }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Loader from "./Loader.vue";
import api from "@/services/api-service";
import t from "@/services/translation-service";

const guid = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export default {
  components: {
    Loader,
  },
  props: {
    files: Array,
    disabled: Boolean,
  },
  data() {
    return {
      uploadingFiles: false,
      attachments: [],
      id: guid(),
      t: t,
    };
  },
  methods: {
    deleteFile(attachment) {
      this.attachments = this.attachments.filter(
        (f) => f.reference !== attachment.reference
      );
      this.$emit("change", this.attachments);
    },
    uploadFormData(formData) {
      const vm = this;
      return api
        .uploadFiles(formData)
        .then((res) => {
          res.data.forEach((f) => vm.attachments.push(f));
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    handleFiles(event) {
      this.uploadingFiles = true;
      const appendFilesToFormData = (files) => {
        const formData = new FormData();
        files.forEach((f) => formData.append("file", f));
        return formData;
      };
      this.uploadFormData(appendFilesToFormData(event.target.files)).finally(
        () => {
          this.uploadingFiles = false;

          this.$emit("change", this.attachments);
        }
      );
    },
  },
  created() {
    this.attachments = this.files;
  },
};
</script>
<style>
.attachmentInput__input {
  opacity: 0;
  overflow: hidden;
  position: fixed;
  z-index: -1;
}

.attachmentInput__label.disabled.primary {
  background-color: lightgray;
  cursor: not-allowed;
}

.attachmentInput__label {
  cursor: pointer;
  display: inline-block;
  margin: 0.5rem 0;
  text-align: center;
}

.attachmentInput__input:focus + .attachmentInput__label {
  outline: 2px dotted lightskyblue;
  outline: -webkit-focus-ring-color auto 5px;
}

.attachmentListing__item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0.125em 0;
  padding: 0.25em;
  font-size: 12px;
}

.attachmentListing__item:nth-child(even) {
  background-color: #f1f1f1;
}

.attachmentListing__item__deleteBtn {
  font-size: 10px;
  padding: 4px 12px;
}
</style>
